import React from 'react'

interface LoadingSpinnerProps {
  /** 한 변 기준 크기(px). 점 크기·간격·튀는 높이가 이 값에 비례한다. */
  size?: number
  /** 레거시 호환용(링 스피너 시절). 지금은 쓰지 않는다. */
  borderWidth?: number
  className?: string
  /**
   * 어두운 배경 위에 올릴 때 true. 점이 흰색이 된다.
   * (갈색 버튼 안에서 갈색 점은 안 보인다)
   */
  onDark?: boolean
}

/**
 * 점 세 개가 차례로 튀는 로딩 표시.
 *
 * 왜 바꿨나
 * --------
 * 예전에는 브랜드 꽃 로고를 1.8초에 한 바퀴 돌렸다. 그런데 꽃이 6방 대칭이라
 * 60도만 돌면 원래 모양으로 돌아온다. 느린 회전과 겹쳐서 멈춘 것처럼 보였다.
 *
 * 덤으로 699×699 PNG를 20~28px로 줄여 쓰던 것도 없어진다. 이제 이미지 요청이
 * 아예 없다.
 *
 * 크기는 두 가지만 쓰인다 — 화면 가운데 28, 버튼 안 20.
 */
const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 28,
  className = '',
  onDark = false,
}) => {
  const dot = size * 0.28
  const gap = size * 0.2
  const lift = size * 0.25

  return (
    <span
      role="status"
      aria-label="불러오는 중"
      className={`inline-flex items-center select-none pointer-events-none ${className}`}
      style={{ gap: `${gap}px`, height: `${size}px` }}
    >
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          style={{
            width: `${dot}px`,
            height: `${dot}px`,
            borderRadius: '50%',
            background: onDark ? '#FFFFFF' : 'rgba(75, 54, 33, 0.8)',
            animation: `tastee-dot 1.05s ease-in-out ${i * 0.14}s infinite`,
            // 애니메이션이 이 값을 읽어 크기에 비례해 튄다
            ['--tastee-dot-lift' as string]: `${-lift}px`,
          }}
        />
      ))}
    </span>
  )
}

export default LoadingSpinner
